import { BaseNotificationsList } from "../../../shared/BaseNotificationList";
import { gymNotificationData, redirectOnClick } from "./utils";

const GymDropdownNotificationList = () => {
  return (
    <BaseNotificationsList
      type="dropdown"
      // query={{}}
      notificationPreviewData={gymNotificationData}
      onRedirect={redirectOnClick}
    />
  );
};

export default GymDropdownNotificationList;
